module.exports = __webpack_public_path__ + "static/img/zhutu智慧施工云平台.97119d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type4-2/zhutu智慧施工云平台.png
// module id = eXsr
// module chunks = 0